import Popup from "@metacrm/metacrm-material-ui/dist/Popup";
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { StyledKnowledgeBaseModalOption } from "./KnowledgeBaseModal.styles";
import Button, { SIZE } from "@metacrm/metacrm-material-ui/dist/Button";
import KbPDFModal from "./KbPDFModal";
import KbLinkModal from "./KbLinkModal";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useOutletContext } from "react-router";
import {
  fetchCategoriesAsyncAction,
  fetchMacroListAsyncAction,
} from "features/metadesk/redux/macro/macro.action";
import { selectMacroList } from "features/metadesk/redux/macro/macro.selector";
import { useDispatch, useSelector } from "react-redux";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useIntl } from "react-intl";

export default function KnowledgeBaseModal({
  open,
  onClose,
  refetch,
  knowledgeBaseData,
}) {
  const [openNextModal, setOpenNextModal] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [entityName] = useOutletContext();
  function handleCloseNextModal() {
    setOpenNextModal(null);
    onClose();
  }

  const hasMacro = knowledgeBaseData?.some(
    (item) => item.sourceType === "Macro"
  );
  const dispatchSnackbar = useDispatchSnackbar();

  async function handleAddMarco() {
    try {
      if (isLoading) return;
      setIsLoading(true);
      await axios.post(`${apiUrl}/api/knowledgeBase/macro`, {
        entityName,
        name: "Macro",
      });
      await refetch();
      onClose();
    } catch (err) {
      console.log(err);
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  }

  const dispatch = useDispatch();
  const macroList = useSelector(selectMacroList);
  useEffect(() => {
    dispatch(fetchMacroListAsyncAction({ entityName }));
  }, []);

  const { formatMessage } = useIntl();
  const options = [
    {
      title: formatMessage({ id: "popup.createKnowledge.fromFile.title" }),
      description: formatMessage({
        id: "popup.createKnowledge.fromFile.description",
      }),
      onClick: () => {
        setOpenNextModal("PDF");
      },
      icon: (
        <i
          className="meta-crm-icon-ic_upload font-size-24"
          style={{ color: "#555" }}
        />
      ),
    },
    {
      title: formatMessage({ id: "popup.createKnowledge.fromWebsite.title" }),
      description: formatMessage({
        id: "popup.createKnowledge.fromWebsite.description",
      }),
      onClick: () => {
        setOpenNextModal("Link");
      },
      icon: (
        <i
          className="meta-crm-icon-ic_link2 font-size-24"
          style={{ color: "#555" }}
        />
      ),
    },
    {
      title: formatMessage({ id: "popup.createKnowledge.fromGitbook.title" }),
      description: formatMessage({
        id: "popup.createKnowledge.fromGitbook.description",
      }),
      onClick: () => {
        setOpenNextModal("GitBook");
      },
      icon: (
        <i
          className="meta-crm-icon-ic_gitbook font-size-24"
          style={{ color: "#555" }}
        />
      ),
    },
    {
      title: formatMessage({ id: "popup.createKnowledge.fromMacro.title" }),
      description: formatMessage({
        id: "popup.createKnowledge.fromMacro.description",
      }),
      onClick: handleAddMarco,
      icon: (
        <i
          className="meta-crm-icon-ic_macro font-size-24"
          style={{ color: "#555" }}
        />
      ),
      button: hasMacro ? "Added" : "Add",
      disabled: macroList.length === 0 || hasMacro,
    },
  ];

  function handleBack() {
    setOpenNextModal(null);
  }

  return (
    <>
      {!openNextModal ? (
        <Popup open={open} onClose={onClose} title="Add Knowledge" size="md">
          <Box display="flex" flexDirection="column" gap="24px 0">
            {options.map((option) => (
              <StyledKnowledgeBaseModalOption
                key={option.title}
                onClick={option?.button ? () => {} : option.onClick}
              >
                <Box display="flex" alignItems="center">
                  <>{option.icon}</>
                  <Box ml="16px">
                    <Box fontSize={16} fontWeight={700} color="#555" mb="8px">
                      {option.title}
                    </Box>
                    <Box color="#777">{option.description}</Box>
                  </Box>
                </Box>
                {option.button ? (
                  <Button
                    size={SIZE.MEDIUM}
                    sx={{ width: "80px" }}
                    onClick={option.onClick}
                    disabled={option.disabled}
                  >
                    {option.button}
                  </Button>
                ) : (
                  <Box>
                    <i
                      className="meta-crm-icon-ic_arrow-right font-size-24"
                      style={{ color: "#777", cursor: "pointer" }}
                    />
                  </Box>
                )}
              </StyledKnowledgeBaseModalOption>
            ))}
          </Box>
        </Popup>
      ) : (
        <>
          {openNextModal === "PDF" && (
            <KbPDFModal
              onClose={handleCloseNextModal}
              onBack={handleBack}
              refetch={refetch}
            />
          )}
          {(openNextModal === "Link" || openNextModal === "GitBook") && (
            <KbLinkModal
              onClose={handleCloseNextModal}
              type={openNextModal}
              onBack={handleBack}
              refetch={refetch}
            />
          )}
        </>
      )}
    </>
  );
}
